import {
    API_SUCCESS,
    API_FAIL,
    GET_CHARTS_DATA,
    FETCH_EMPLOYEE_DASHBOARD_REQUEST,
    FETCH_EMPLOYEE_DASHBOARD_SUCCESS,
    FETCH_EMPLOYEE_DASHBOARD_FAILURE,
    SEND_BIRTHDAY_WISHES_REQUEST,
    SEND_BIRTHDAY_WISHES_SUCCESS,
    SEND_BIRTHDAY_WISHES_FAILURE,
    FETCH_HR_DASHBOARD_REQUEST,
    FETCH_HR_DASHBOARD_SUCCESS,
    FETCH_HR_DASHBOARD_FAILURE,
    FETCH_HOD_DASHBOARD_REQUEST,
    FETCH_HOD_DASHBOARD_SUCCESS,
    FETCH_HOD_DASHBOARD_FAILURE,
    FETCH_ORG_CHART_FAILURE,
    FETCH_ORG_CHART_SUCCESS,
    FETCH_ORG_CHART_REQUEST,
    FETCH_HOD_DASHBOARDPROJECTVIEW_REQUEST,
    FETCH_HOD_DASHBOARDPROJECTVIEW_SUCCESS,
    FETCH_HOD_DASHBOARDPROJECTVIEW_FAILURE,
    FETCH_HR_DASHBOARDPROJECTVIEW_REQUEST,
    FETCH_HR_DASHBOARDPROJECTVIEW_SUCCESS,
    FETCH_HR_DASHBOARDPROJECTVIEW_FAILURE
} from "./actionTypes";

const INIT_STATE = {
    chartsData: [],
    dashboardData: null,
    orgChartData: null,
    projectViewData: [],
    hrprojectViewData: [],
    loading: false,
    error: null,
    success: false,
};

const Dashboard = (state = INIT_STATE, action) => {
    switch (action.type) {
        case API_SUCCESS:
            switch (action.payload.actionType) {
                case GET_CHARTS_DATA:
                    return {
                        ...state,
                        chartsData: action.payload.data
                    };

                default:
                    return state;
            }
        case API_FAIL:
            switch (action.payload.actionType) {
                case GET_CHARTS_DATA:
                    return {
                        ...state,
                        earningChartDataError: action.payload.error
                    };


                default:
                    return state;
            }
        case FETCH_EMPLOYEE_DASHBOARD_REQUEST:
            return { ...state, loading: true, error: null, success: false };

        case FETCH_EMPLOYEE_DASHBOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                dashboardData: action.payload.data,
                success: true,
            };

        case FETCH_EMPLOYEE_DASHBOARD_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false };

        case SEND_BIRTHDAY_WISHES_REQUEST:
            return { ...state, loading: true, success: false, error: null };

        case SEND_BIRTHDAY_WISHES_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };

        case SEND_BIRTHDAY_WISHES_FAILURE:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };

        case FETCH_HR_DASHBOARD_REQUEST:
            return { ...state, loading: true, error: null, success: false };

        case FETCH_HR_DASHBOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                dashboardData: action.payload.data,
                success: true,
            };

        case FETCH_HR_DASHBOARD_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false };

        case FETCH_HOD_DASHBOARD_REQUEST:
            return { ...state, loading: true, error: null, success: false };

        case FETCH_HOD_DASHBOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                dashboardData: action.payload.data,
                success: true,
            };

        case FETCH_HOD_DASHBOARD_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false };
        case FETCH_ORG_CHART_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                success: false,
            };

        case FETCH_ORG_CHART_SUCCESS:
            return {
                ...state,
                loading: false,
                orgChartData: action.payload.data,
                success: true,
            };

        case FETCH_ORG_CHART_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false,
            };

        case FETCH_HOD_DASHBOARDPROJECTVIEW_REQUEST:
            return { ...state, loading: true, error: null, success: false };

        case FETCH_HOD_DASHBOARDPROJECTVIEW_SUCCESS:
            return {
                ...state,
                loading: false,
                projectViewData: action.payload.data,
                success: true,
            };

        case FETCH_HOD_DASHBOARDPROJECTVIEW_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false };

        case FETCH_HR_DASHBOARDPROJECTVIEW_REQUEST:
            return { ...state, loading: true, error: null, success: false };

        case FETCH_HR_DASHBOARDPROJECTVIEW_SUCCESS:
            return {
                ...state,
                loading: false,
                hrprojectViewData: action.payload.data,
                success: true,
            };

        case FETCH_HR_DASHBOARDPROJECTVIEW_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false };
        default:
            return state;
    }
};


export default Dashboard;